import React, { useState } from 'react';
import {
  Box,
  Button,
  Grow,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CTAutocomplete from 'components/CTAutocomplete';
import ReactCardFlip from 'react-card-flip';
import { tokens } from 'theme/tokens';
import { CloseOutlined, CloseRounded } from '@mui/icons-material';

const NextStatusModal = ({
  actions,
  yard_address,
  fnOnNextStatusClick,
  handleClose,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [isAddressFormVisible, setAddressFormVisible] = useState(false);
  const [command, setCommand] = useState(null);

  const formik = useFormik({
    initialValues: { ...yard_address },

    validationSchema: Yup.object().shape({
      street: Yup.string().max(100).required('City Name is required.'),
      city: Yup.string().min(2).max(50).required('City Name is required.'),
      state: Yup.string().min(2).max(25).required('State Name is required.'),
      country: Yup.string().max(25).required('Country Name is required.'),
    }),

    onSubmit: values => {
      const trimmed_data = {};
      Object.keys(values).forEach(key => trimmed_data[key] = typeof (values[key]) === 'string' ? values[key].trim() : values[key]);
      fnOnNextStatusClick(command, trimmed_data);
    },
  });

  const onNextStatusClick = (command) => {
    if (command === 'CHECK IN') {
      command = command.replace(' ', '_');
    }
    if (command === 'YARD' || command === 'YARD_IN' || command === 'YARD_PULL' || command === 'STREET_TURN' ||
      command === 'DRYRUN' || command === 'CONTAINER_DROP') {
      setCommand(command);
      setAddressFormVisible(true);
    } else {
      fnOnNextStatusClick(command);
    }
  };

  return (
    <Box
      sx={{
        height:'auto',
        py: 1.5,
        px: 2,
        border: `1px solid ${colors.neutral[200]}`,
        borderRadius: '6px',
        textAlign: 'center',
        gap: 1.5,
      }}
    >
      <Box>
        {actions && actions.length === 0 ? <Typography variant='subtitle1' style={{ margin: 'auto' }}>No Next Action</Typography> :
          <React.Fragment>
            <Box display={'flex'} justifyContent={'space-between'}>
              <Typography variant='subtitle2' sx={{fontWeight: 500, color: colors.neutral[700], textTransform: 'uppercase' }}>{'Select next action for your load.'}</Typography>
              <IconButton size='small' sx={{border: `1px solid ${colors.red[200]}`}} onClick={handleClose} ><CloseRounded sx={{color: colors.red[300]}} /></IconButton>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'space-evenly',
                py: 1.5,
                px: 2,
                border: `1px solid ${colors.neutral[200]}`,
                borderRadius: '6px',
              }}
            >
              {actions.map(status => {
                return (
                  <Button key={`leg-${status}`}
                    variant='contained'
                    color='primary'
                    onClick={() => onNextStatusClick(status)}
                  >
                    {status}
                  </Button>
                );
              })
              }
            </Box>
          </React.Fragment>
        }
        {isAddressFormVisible &&<Box>
          <Grow
            in={isAddressFormVisible}
            style={{ transformOrigin: '0 0 0' }}
            {...(isAddressFormVisible ? { timeout: 1000 } : {})}
          >
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <Typography variant='subtitle2'>Please provide destination address</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <CTAutocomplete
                    margin={'none'}
                    fnHandleSelectedLocation={loc => {
                      formik.setFieldValue('street', loc.addressLabel);
                      formik.setFieldValue('city', loc.city);
                      formik.setFieldValue('zipcode', loc.postalCode);
                      formik.setFieldValue('state', loc.stateCode);
                      formik.setFieldValue('country', loc.countryCode);
                    }}
                  />
                </Grid>
              </Grid>
              <Box
                display='flex'
                justifyContent='flex-end'
                p={2}>
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                >OK
                </Button>
                <Button color='primary' onClick={() => setAddressFormVisible(false)}>Cancel</Button>
              </Box>
            </form>
          </Grow>
        </Box>}
      </Box>
    </Box>
  );
};

export default NextStatusModal;